import React from 'react';
import ReactDOM from 'react-dom';

import Oddbods from '../routes/oddbods-app';

// global css loaded
import '../../css/dist/oddbods.scss';
// import ErrorBoundary from '../utils/error-boundary';
import { StyleSheetManager } from 'styled-components';

var prerender = navigator.userAgent && navigator.userAgent.includes("Prerender");
// inject css in DOM only when google bot, or any crawler tries to access the site.
// otherwise keep it false (default behaviour of styled components)
const App = () => {
  return (
    <StyleSheetManager disableCSSOMInjection={prerender}>
      <Oddbods />
    </StyleSheetManager>
  );
};

ReactDOM.render(<App />, document.getElementById('oddbods-app'));
